__turbopack_context__.v({
  "testimonial": "UspTestimonials-module-scss-module__E2jEeq__testimonial",
  "testimonial-caption": "UspTestimonials-module-scss-module__E2jEeq__testimonial-caption",
  "testimonial-container": "UspTestimonials-module-scss-module__E2jEeq__testimonial-container",
  "testimonial-heading": "UspTestimonials-module-scss-module__E2jEeq__testimonial-heading",
  "testimonial-slide": "UspTestimonials-module-scss-module__E2jEeq__testimonial-slide",
});
